import './index.scss';

import { TrainingModule } from '@interfaces/training.interface';

export default function TrainingModuleCard(props: {
  module: TrainingModule;
  /// Marks the card as the current pick when it's one of a set being chosen from.
  isSelected?: boolean;
  /// Rendered under the description; used for state a picker needs to explain.
  badge?: string;
  onClick?: () => void;
}) {
  const attributes = props.module.attributes;

  const classNames = ['training-module-card', 'card'];
  if (props.isSelected) classNames.push('is-selected');

  const content = <>
    <div className='training-module-thumbnail'>
      {attributes.thumbnailURL ?
        <img src={attributes.thumbnailURL} alt='' aria-hidden='true' /> :
        <span className='thumbnail-fallback' aria-hidden='true'>{attributes.name.slice(0, 1)}</span>}
    </div>

    <div className='training-module-body'>
      <h3>{attributes.name}</h3>
      {attributes.description ? <p className='training-module-description'>{attributes.description}</p> : null}
      {props.badge ? <span className='training-module-badge'>{props.badge}</span> : null}
    </div>
  </>;

  if (!props.onClick) {
    return <div className={classNames.join(' ')}>{content}</div>
  }

  return <button
    type='button'
    className={classNames.join(' ')}
    aria-pressed={props.isSelected}
    onClick={props.onClick}>
    {content}
  </button>
}
